exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal.show{background-color:rgba(0,0,0,.3)}.modal.show .modal-header{border-bottom:0}.modal.show .modal-body{padding:1rem 2rem}.modal.show .modal-footer{border-top:0}", ""]);

// exports
